import { CustomSelectTextField, CustomTextField, SampleCheckbox, SingleFormBoxScene, SingleTableBoxScene } from "@/shared/components/ui";
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { gridSizeMdLg12, ROUTER_PATHS } from "@/shared";
import { toast } from "react-toastify";
import { useCreateIncidents, useGetActivityType } from "../../actions/noc-module.actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ActivityType, Incidents } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import * as yup from 'yup';
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";

type SaveFormData = Omit<Incidents, 'idIncidence'>;

export default function ParametrosIncidenciaCrearPage() {

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoParametrosPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocParametrosNav;

    const [listaTipoActividad, setListaTipoActividad] = useState<any[]>([]);
    const useActivityTypeMutation = useGetActivityType();

    const useCreateIncidentsTypeMutation = useCreateIncidents();

    const newIncidentsTypeSchema = yup.object({
        idActivityType: yup.string().required('Tipo de Actividad Requerido'),
        name: yup.string().required('Nombre de la incidencia requerido'),
    });

    const form = useForm<SaveFormData>({
        resolver: yupResolver(newIncidentsTypeSchema as any),
        defaultValues: {
            name: '',
            isBoxInstallation: false,
            requireCoordinates: false,
            idActivityType: ''
        },
    });

    const {
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = form;

    const onSave = () => {
        if (!isValid) return;

        useCreateIncidentsTypeMutation.mutate(form.getValues(), {
            onSuccess: () => {
                navigate(returnUrlOrdenTrabajoParametrosPage);
                toast.success("Incidencia registrada correctamente")
            },
            onError: (error: any) => {
                if (error.response?.data?.message) {
                    toast.error(error.response.data.message);
                } else {
                    console.error('Error al crear la Incidencia:', error);
                    toast.error('Error al crear la Incidencia');
                }
            }
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            const response = await useActivityTypeMutation.mutateAsync([]);
            setListaTipoActividad(response.data ?? []);
        };
        fetchData();
    }, []);

    return (
        <>
            <SingleTableBoxScene
                title={"Crear Incidencia"}
                textRedirect={"Atras"}
                iconRedirect={<ArrowBack />}
                urlRedirect={`${returnUrlOrdenTrabajoParametrosPage}`}
                visibleReport={true}
            >

                <SingleFormBoxScene
                    titlePage={""}
                    onCancel={() => {
                        navigate(returnUrlOrdenTrabajoParametrosPage);
                    }}
                    containerMaxWidth={"sm"}
                    py={6}
                    onSave={handleSubmit(onSave)}
                >

                    <CustomSelectTextField<ActivityType>
                        label="Tipo de Actividad"
                        defaultValue={form.getValues().idActivityType || ''}
                        // options
                        options={listaTipoActividad || []}
                        labelKey="nameActivityType"
                        valueKey="idActivityType"
                        menuItemKey="idActivityType"
                        // errors
                        register={form.register('idActivityType')}
                        error={errors.idActivityType}
                        helperText={errors.idActivityType?.message}
                        size={gridSizeMdLg12}
                    />

                    <CustomTextField
                        label="Nombre de la Incidencia"
                        name="name"
                        control={control}
                        defaultValue={form.getValues().name || ''}
                        error={errors.name}
                        helperText={errors.name?.message ?? ''}
                        size={gridSizeMdLg12}
                    />

                    <Grid item {...gridSizeMdLg12}>
                        <SampleCheckbox
                            label="Requiere Coordenadas"
                            name="requireCoordinates"
                            control={control}
                            defaultValue={!!form.getValues().requireCoordinates || false}
                            textNote={"Obligatoriedad para el ingreso de coordenadas"}
                            isState
                        />
                    </Grid>

                    <Grid item {...gridSizeMdLg12}>
                        <SampleCheckbox
                            label="Requiere Cajas"
                            name="isBoxInstallation"
                            control={control}
                            defaultValue={!!form.getValues().isBoxInstallation || false}
                            textNote={"Obligatoriedad para instalación de Cajas / Naps"}
                            isState
                        />
                    </Grid>

                </SingleFormBoxScene>
            </SingleTableBoxScene>
        </>
    )
}